import PropTypes from 'prop-types'

export * from './products'
export * from './cart'
export * from './checkout'

export const ChildrenShape = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node
])



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/shop/src/js/shapes/index.js